import { c as _c } from "react/compiler-runtime";
import { type QueryOrdering } from '@/api/generated/model';
import { AggregateBy } from '@/domains/dashboard/components/GlobalfiltersRow';
import { FILTERS, TAG_PREFIX } from '@/models/common/filters';
import { IntelligenceTableRow, mapToIntelligenceTableRow } from '@/models/intelligence-table-row';
import { InteractionAggregatesPaginated } from '@/models/interaction-aggregates/internal-models';
import { useFetchCustomAggregateCategories } from '@/models/interaction-aggregates/useFetchInteractionAggregates';
import { useEnvironmentContext } from '@/providers/environment.provider';
import { useProjectsContext } from '@/providers/projects-provider';
import { GroupByValue } from '@/types/groupBy';
import { useMemo } from 'react';
export function getBonusFilter(groupBy: GroupByValue) {
  if (groupBy.startsWith(TAG_PREFIX)) return groupBy;
  if (groupBy === 'user_action') return FILTERS.columnUserAction;
  if (groupBy === 'user_intent') return FILTERS.columnIntent;
  if (groupBy === 'negative_user_intent_v2') return FILTERS.columnNegativeIntentV2;
  if (groupBy === 'keyword') return FILTERS.columnSubject;
  if (groupBy === 'topic') return FILTERS.columnTopic;
  if (groupBy === 'data_source') return FILTERS.columnDataSource;
}
export function useBuildMappedRows(aggregatesData, groupBy, sortBy, isAggregatesLoading, aggregateBy) {
  const $ = _c(11);
  const {
    enableLLMIssuesV2
  } = useEnvironmentContext();
  const {
    projectId
  } = useProjectsContext();
  let t0;
  if ($[0] !== groupBy || $[1] !== projectId) {
    t0 = {
      payload: {
        project_id: projectId,
        aggregate_kind: groupBy
      }
    };
    $[0] = groupBy;
    $[1] = projectId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    data: customAggregateCategoriesData
  } = useFetchCustomAggregateCategories(t0);
  let t1;
  if ($[3] !== aggregateBy || $[4] !== aggregatesData?.aggregates || $[5] !== customAggregateCategoriesData || $[6] !== enableLLMIssuesV2 || $[7] !== groupBy || $[8] !== isAggregatesLoading || $[9] !== sortBy) {
    t1 = [...(aggregatesData?.aggregates ?? [])].map(agg => mapToIntelligenceTableRow(agg, {
      sortBy,
      groupBy,
      isLoadingAggregates: isAggregatesLoading,
      aggregateBy,
      enableLLMIssuesV2,
      isCustomAggregateCategory: customAggregateCategoriesData?.map(_temp).includes(agg.groupName) ?? false
    })) ?? [];
    $[3] = aggregateBy;
    $[4] = aggregatesData?.aggregates;
    $[5] = customAggregateCategoriesData;
    $[6] = enableLLMIssuesV2;
    $[7] = groupBy;
    $[8] = isAggregatesLoading;
    $[9] = sortBy;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const mappedRows = t1;
  return mappedRows;
}
function _temp(ca) {
  return ca.name;
}